import {InformatDefaultPage} from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import {GridContainer, GridItem, GridRow} from "pu-crossproduct-components/build/components/Atoms/Grid";
import {Trans, useTranslation} from "react-i18next";
import styled from "styled-components";
import {Body2, Caption2, H1} from "pu-crossproduct-components/build/components/Atoms/Type/"
import {Icon, Size} from "pu-crossproduct-components/build/components/Atoms/Icons/Icon";
import {Icons} from "pu-crossproduct-components/build/components/Molecules/Navigation/IconButton";
import {Link, LinkColors} from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import {LogoutUrl} from "../../../../routing/InformatExternalLinks/InformatExternalLinks";
import React from "react";

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 36px;
`

const ErrorMsg = styled(Caption2)`
    margin-top: 100px;
`

export interface Props {
    errorMessage: string
}

export const InformatAccountPickerError: React.FC<Props> = props => {
    const {t} = useTranslation();


    return <InformatDefaultPage>

        <GridContainer>
            <GridRow>
                <GridItem col={0} laptop={2}/>
                <GridItem col={12} laptop={8}>
                    <Content>
                        <Icon icon={Icons.error} size={Size.extraLarge} />
                        <H1><Trans t={t} values={{errorMessage: props.errorMessage}} components={{GoBackLink: <Link href={LogoutUrl} color={LinkColors.type} />}}>twoFactorInformatGeneralErrorTitle</Trans></H1>
                        <Body2><Trans t={t} values={{errorMessage: props.errorMessage}} components={{GoBackLink: <Link href={LogoutUrl} color={LinkColors.type} />}}>twoFactorInformatGeneralErrorDescription</Trans></Body2>
                        <ErrorMsg><Trans t={t} values={{errorMessage: props.errorMessage}} components={{GoBackLink: <Link href={LogoutUrl} color={LinkColors.type} />}}>twoFactorInformatGeneralErrorDetail</Trans></ErrorMsg>
                    </Content>
                </GridItem>
                <GridItem col={0} laptop={2}/>
            </GridRow>
        </GridContainer>
    </InformatDefaultPage>
}
